import { gql } from '@apollo/client'

export const CREATE_SITE = gql`
  mutation CreateSite($site: createSiteInput!) {
    createSite(input: $site)
  }
`

export const EDIT_SITE = gql`
  mutation EditSite($site: changeSiteInput!) {
    changeSite(input: $site)
  }
`

export const CHANGE_BUSINESS_SITE_KREDIT_SETTINGS = gql`
  mutation ChangeSiteKreditSettings($input: ChangeBusinessClientSiteKreditSettingsInput!) {
    changeBusinessClientSiteKreditSettings(input: $input)
  }
`
